import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { PageViewComponent } from '@tytapp/app/pages/content-pages/page-view/page-view.component';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { ContentModule } from '@tytapp/content';


@NgModule({
    declarations: [
        PageViewComponent
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        ContentModule,
        RouterModule.forChild([
            {
                path: 'edit',
                loadChildren: () => import('../content-editor-pages').then(m => m.ContentEditorPagesModule)
            },
            { path: ':id', component: PageViewComponent },
            { path: '', redirectTo: '/', pathMatch: 'full' }
        ]),
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        CommonUiModule,
        MatTooltipModule,
        MatMenuModule,
    ]
})
export class ContentPagesModule {
}
